/*
 * @Author: 🐝
 * @Date: 2024-09-11 12:12:41
 * @LastEditors: Ant🐜
 * @LastEditTime: 2024-09-11 15:48:04
 * @Description: 描述一下
 */
import axios from '../utils/axios'

// 核销记录列表
export function getWriteoffList(params) {
  return axios.post('/order/apiOrderAh5Service/getWriteoffList', params)
}

// 运费险详情
export function getInsuranceDetail(params = {}) {
  return axios.post('/settle/apiSettleAwService/getInsuranceDetail', params)
}
//订单详情
export function getOrderDetail(params = {}) {
  return axios.post('/order/apiOrderAwService/getOrderDetail', params)
}
